/* Stribe homepage (home-v2) — vanilla scroll scenes. CSS vars drive everything; all motion off under prefers-reduced-motion.
   Scenes: opener (film inside STRIBE, zoom into the I, captions), lit manifesto, counters, lineup rise,
   founder card -> full bleed, light map, B/A track, click-to-play testimonials, parallax, reveals. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vh = window.innerHeight, vw = window.innerWidth;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ss(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function prog(el) { var r = el.getBoundingClientRect(); return clamp(-r.top / Math.max(1, r.height - vh), 0, 1); }

  // ---------- nav ----------
  var nav = document.getElementById('gnav'), tog = nav.querySelector('.gnav-toggle');
  tog.addEventListener('click', function () {
    var o = nav.classList.toggle('open');
    tog.setAttribute('aria-expanded', o ? 'true' : 'false'); tog.setAttribute('aria-label', o ? 'Close menu' : 'Open menu');
  });
  function closeNav() { nav.classList.remove('open'); tog.setAttribute('aria-expanded', 'false'); tog.setAttribute('aria-label', 'Open menu'); }
  nav.querySelectorAll('.gnav-menu a').forEach(function (a) { a.addEventListener('click', closeNav); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('open')) { closeNav(); tog.focus(); } });
  var darks = Array.prototype.slice.call(document.querySelectorAll('section.dark'));
  var opDark = false;
  function navTheme() {
    var y = nav.offsetHeight + 4, d = false;
    for (var i = 0; i < darks.length; i++) { var r = darks[i].getBoundingClientRect(); if (r.top <= y && r.bottom >= y) { d = true; break; } }
    var ro = op.getBoundingClientRect(); if (ro.top <= y && ro.bottom >= y) d = false;
    nav.classList.toggle('on-dark', d || opDark);
    nav.classList.toggle('top', window.scrollY < 8);
  }

  // ---------- opener: black film -> card on white ----------
  var op = document.querySelector('.op'), stick = op.querySelector('.op-stick'), vid = op.querySelector('.op-v');
  vid.addEventListener('playing', function () { vid.classList.add('playing'); });
  if (!vid.paused && vid.readyState > 2) vid.classList.add('playing');
  function opScene() {
    var p = reduce ? 0 : prog(op);
    var c = ss(0.12, 0.62, p);               // film shrinks into a card
    var w = ss(0.1, 0.42, p);                // page turns white
    var v = Math.round(255 * w);
    stick.style.setProperty('--bg', v + ' ' + v + ' ' + v);
    stick.style.setProperty('--c', c.toFixed(4));
    stick.style.setProperty('--co', (1 - ss(0.02, 0.2, p)).toFixed(3));
    stick.style.setProperty('--ao', ss(0.55, 0.8, p).toFixed(3));
    opDark = w < 0.5 && op.getBoundingClientRect().bottom > nav.offsetHeight + 4;
  }
  function wmSetup() {}

  // ---------- manifesto words ----------
  var words = document.querySelectorAll('.lit .w'), lit = document.querySelector('.lit');
  function litScene() {
    if (!lit) return;
    var r = lit.getBoundingClientRect();
    var t = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35), 0, 1);
    var n = Math.round(t * words.length);
    for (var i = 0; i < words.length; i++) words[i].classList.toggle('on', i < n);
  }

  // ---------- lineup ----------
  var lu = document.querySelector('.lu-track'), cards = lu.querySelectorAll('.lu-card'), luDots = document.querySelectorAll('.lu-dots button');
  function luScene() {
    var desk = vw > 1060;
    var r = lu.getBoundingClientRect();
    for (var i = 0; i < cards.length; i++) {
      var base = desk ? clamp((vh - r.top) / (vh * 0.75) - i * 0.12, 0, 1) : clamp((vh - r.top) / (vh * 0.6), 0, 1);
      cards[i].style.setProperty('--q', ss(0, 1, base).toFixed(3));
    }
  }
  lu.addEventListener('scroll', function () {
    var c = lu.scrollLeft + lu.clientWidth / 2, best = 0, bd = 1e9;
    cards.forEach(function (cd, i) { var m = cd.offsetLeft + cd.offsetWidth / 2, d = Math.abs(m - c); if (d < bd) { bd = d; best = i; } });
    luDots.forEach(function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
  }, { passive: true });
  luDots.forEach(function (b, i) { b.addEventListener('click', function () { lu.scrollTo({ left: cards[i].offsetLeft - (lu.clientWidth - cards[i].offsetWidth) / 2, behavior: 'smooth' }); }); });

  // ---------- gear strip: grid from 1060px, swipe row below it; one dot per snap stop ----------
  var sh = document.querySelector('.sh-track'), shDots = document.querySelector('.sh-dots');
  if (sh && shDots) {
    var shCards = sh.querySelectorAll('.sh-card'), shStops = [], shCur = -1, shRaf = 0;
    // layout reads live here (load, resize), never in the scroll handler
    var shMeasure = function () {
      var max = sh.scrollWidth - sh.clientWidth, pad = shCards.length ? shCards[0].offsetLeft : 0;
      shStops = [];
      if (max > 1) {
        for (var i = 0; i < shCards.length; i++) {
          var x = Math.min(max, shCards[i].offsetLeft - pad);
          if (!shStops.length || x - shStops[shStops.length - 1] > 1) shStops.push(x);
          if (x >= max) break;
        }
      }
      var n = shStops.length > 1 ? shStops.length : 0;
      if (shDots.children.length !== n) {
        shDots.textContent = '';
        for (var j = 0; j < n; j++) shDots.appendChild(document.createElement('span'));
      }
      if (n) sh.setAttribute('tabindex', '0'); else sh.removeAttribute('tabindex');
      shCur = -1; shPaint();
    };
    var shPaint = function () {
      shRaf = 0;
      var x = sh.scrollLeft, best = 0, bd = 1e9;
      for (var i = 0; i < shStops.length; i++) { var d = Math.abs(shStops[i] - x); if (d < bd) { bd = d; best = i; } }
      if (best === shCur) return;
      shCur = best;
      for (var j = 0; j < shDots.children.length; j++) shDots.children[j].classList.toggle('on', j === best);
    };
    sh.addEventListener('scroll', function () { if (!shRaf) shRaf = requestAnimationFrame(shPaint); }, { passive: true });
    shDots.addEventListener('click', function (e) {
      var i = Array.prototype.indexOf.call(shDots.children, e.target);
      if (i >= 0) sh.scrollTo({ left: shStops[i], behavior: reduce ? 'auto' : 'smooth' });
    });
    if ('ResizeObserver' in window) new ResizeObserver(shMeasure).observe(sh);
    else { window.addEventListener('resize', shMeasure); shMeasure(); }
  }

  // ---------- founder ----------
  var fd = document.querySelector('.fd'), fdStick = fd.querySelector('.fd-stick');
  function fdScene() {
    var r = fd.getBoundingClientRect();
    // enter: card already growing while it scrolls into view; pinned: finish expanding, then copy
    var inP = clamp(1 - r.top / vh, 0, 1), p = prog(fd);
    var k = 1 - (0.35 * ss(0, 1, inP) + 0.65 * ss(0, 0.45, p));
    fdStick.style.setProperty('--k', reduce ? 0 : k.toFixed(4));
    fdStick.style.setProperty('--t', reduce ? 1 : ss(0.4, 0.7, p).toFixed(3));
  }

  // ---------- parallax ----------
  var pars = document.querySelectorAll('.comm');
  function parScene() {
    pars.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      el.style.setProperty('--py', clamp((vh - r.top) / (vh + r.height), 0, 1).toFixed(3));
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      opScene(); litScene(); luScene(); fdScene(); parScene(); navTheme();
    });
  }
  function onResize() { vh = window.innerHeight; vw = window.innerWidth; wmSetup(); onScroll(); }
  wmSetup(); onScroll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { wmSetup(); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  var rzT; window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - vw) < 2 && Math.abs(window.innerHeight - vh) < 120) return; clearTimeout(rzT); rzT = setTimeout(onResize, 120); });
  // pause the film when it is off screen
  // the film loads only after the page has loaded (poster is the LCP); reduced motion keeps the poster
  var opIn = true;
  function vplay() { if (!vid.getAttribute('src') || !opIn) return; var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
  function loadFilm() {
    if (reduce || vid.getAttribute('src')) return;
    var src = window.matchMedia('(max-width: 760px)').matches ? (vid.dataset.srcM || vid.dataset.src) : vid.dataset.src;
    if (!src) return;
    vid.src = src;
    vplay();
  }
  // start on first interaction, or 6s after load: the poster stays the LCP and slow connections get the page first
  function armFilm() { setTimeout(loadFilm, 6000); }
  ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) { window.addEventListener(ev, loadFilm, { once: true, passive: true }); });
  if (document.readyState === 'complete') armFilm(); else window.addEventListener('load', armFilm);
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { opIn = e.isIntersecting; if (opIn) vplay(); else vid.pause(); }); }).observe(op);

  // ---------- counters ----------
  function count(el) {
    var to = +el.dataset.to, t0 = null, d = 1600;
    if (reduce) { el.textContent = to.toLocaleString('en-US'); return; }
    function step(ts) { if (!t0) t0 = ts; var k = clamp((ts - t0) / d, 0, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4))).toLocaleString('en-US'); if (k < 1) requestAnimationFrame(step); }
    el.textContent = '0'; requestAnimationFrame(step);
  }

  // ---------- reveals / map / counters ----------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.classList.contains('num')) count(el); else el.classList.add('in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    document.querySelectorAll('.rv, .dmap, .num').forEach(function (el) { io.observe(el); });
  } else document.querySelectorAll('.rv, .dmap').forEach(function (el) { el.classList.add('in'); });

  // ---------- testimonials ----------
  document.querySelectorAll('.tv .play').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = document.createElement('video');
      v.src = b.dataset.src; v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true;
      v.setAttribute('aria-label', b.getAttribute('aria-label').replace('Play ', ''));
      b.replaceWith(v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
  });

  // ---------- signup: Shopify customer form; validate here, submit natively ----------
  var form = document.getElementById('sub');
  if (form) form.addEventListener('submit', function (ev) {
    var inp = form.querySelector('input[type="email"]'), msg = form.querySelector('.sub-msg');
    if (!inp.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value)) {
      ev.preventDefault(); msg.textContent = msg.dataset.invalid || 'Please enter a valid email address.'; inp.focus();
    }
  });
})();

// globe.js (canvas, ~25KB) loads only when the alumni section nears the viewport
(function () {
  var cv = document.getElementById('globe'); if (!cv) return;
  function load() { if (cv.dataset.loaded) return; cv.dataset.loaded = '1'; var s = document.createElement('script'); s.src = cv.dataset.src; s.async = true; document.body.appendChild(s); }
  if (!('IntersectionObserver' in window)) return load();
  var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '1200px 0px' });
  io.observe(cv);
})();
